import { authorsActions } from '../actions'
import ValidateFormObject, { validates } from '../utils/ValidateFormObject'
const {
  FETCH_AUTHOR,
  FETCHING_AUTHOR,
  FETCH_AUTHOR_ERROR,
  FETCH_AUTHORS,
  FETCHING_AUTHORS,
  FETCH_AUTHORS_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_AUTHOR,
  DELETE_AUTHOR,
  ADD_AUTHOR,
  EDIT_AUTHOR,
  FORM_TOUCHED,
  NEW_FORM_AUTHOR,
  AUTHOR_FORM_ERROR,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  RESET_STATE
} = authorsActions

const initialState = {
  loadingAuthor: false,
  loadingAuthors: false,
  fetchAuthorError: false,
  fetchAuthorsError: false,
  authors: [],
  order: {
    column: 'nome',
    direction: 1
  },
  authorsPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  author: {
    nome: '',
    documento: '',
    email: '',
    especializacao: '',
    curriculo: '',
    foto: '',
    avatarFile: '',
    imagePreviewUrl: '',
    exibirFotoPwa: true,
    removePhoto: false
  },
  authorFormErrors: {},
  authorFormTouched: false,
  modalOpen: false
}

const authorSchema = {
  add: {
    nome: {
      maxValue: 100,
      minValue: 3,
      required: true
    },
    especializacao: {
      required: false,
      maxValue: 100
    },
    curriculo: {
      required: false
    },
    documento: {
      maxValue: 18,
      required: true,
      func: validates.cpf,
      errorMessage: 'Este campo deve conter um número de CPF válido.'
    },
    email: {
      required: false,
      func: validates.email,
      errorMessage: 'Este campo deve conter um e-mail válido.'
    },
    foto: {
      required: false
    }
  },
  edit: {
    nome: {
      maxValue: 100,
      required: true,
      minValue: 3
    },
    especializacao: {
      required: false,
      maxValue: 100
    },
    curriculo: {
      required: false
    },
    documento: {
      maxValue: 18,
      required: true,
      func: validates.cpf,
      errorMessage: 'Este campo deve conter um número de CPF válido.'
    },
    email: {
      required: false,
      func: validates.email,
      errorMessage: 'Este campo deve conter um e-mail válido.'
    },
    foto: {
      required: false
    }
  }
}

const AuthorValidate = new ValidateFormObject(authorSchema)

const authors = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_AUTHOR:
      formSchemaType = action.author._id ? 'edit' : 'add'
      return {
        ...state,
        author: action.author,
        authorFormErrors: AuthorValidate.validate({
          formObject: action.author,
          formSchemaType
        })
      }
    case AUTHOR_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.author._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        authorFormErrors: AuthorValidate.validate({
          formObject: state.author,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_AUTHOR:
      return {
        ...state,
        author: { ...initialState.author },
        authorFormErrors: AuthorValidate.validate({}),
        authorFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        authorFormTouched: true
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case CHANGE_PAGE:
      return {
        ...state,
        authorsPagination: {
          ...state.authorsPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        authorsPagination: {
          ...state.authorsPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_AUTHOR:
      formSchemaType = (action.author || {})._id ? 'edit' : 'add'
      return {
        ...state,
        author: action.author,
        loadingAuthor: false,
        fetchauthorError: false,
        authorFormTouched: false,
        authorFormErrors: AuthorValidate.validate({
          formObject: action.author,
          formSchemaType
        })
      }
    case FETCHING_AUTHOR:
      return {
        ...state,
        loadingAuthor: true,
        fetchAuthorError: false
      }
    case DELETE_AUTHOR:
      return {
        ...state,
        loadingAuthors: false,
        fetchAuthorError: false,
        authors: state.authors.map(author => {
          if (author._id === action.author._id) {
            return action.author
          }
          return author
        })
      }
    case FETCH_AUTHOR_ERROR:
      return {
        ...state,
        loadingAuthor: false,
        author: { ...initialState.author },
        fetchAuthorError: action.error
      }
    case FETCH_AUTHORS:
      return {
        ...state,
        loadingAuthors: false,
        authors: action.authors,
        fetchAuthorsError: false,
        order: action.order,
        authorsPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_AUTHOR:
      return {
        ...state,
        authors: state.authors.map(author => {
          if (author._id === action.author._id) {
            return action.author
          }
          return author
        }),
        loadingAuthors: false,
        fetchAuthorError: false,
        loadingAuthor: false,
        fetchAuthorsError: false
      }
    case FETCHING_AUTHORS:
      return {
        ...state,
        loadingAuthors: true,
        fetchAuthorsError: false
      }
    case FETCH_AUTHORS_ERROR:
      return {
        ...state,
        loadingAuthors: false,
        fetchAuthorError: action.error,
        loadingAuthor: false
      }
    case ADD_AUTHOR:
      return {
        ...state,
        loadingAuthors: false,
        fetchAuthorError: false,
        loadingAuthor: false,
        authors: [...state.authors, action.author]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default authors



// WEBPACK FOOTER //
// ./src/reducers/authors.js